import {ZIDX, ZIDXPage} from "../../../standalone/standaloneLibrary.js";
import jQuery from "jquery";
const $ = jQuery;


export class ZIDXAccountCrmConnectionEdit implements ZIDXPage{
    zidx:ZIDX;
    constructor(zidx:ZIDX) {
        this.zidx = zidx;
    }
    getPageClass(){
        return "zidxAccountCrmConnectionEditContainer";
    }
    render(){
        // console.log("CRM Connection Edit");
    }
}
